import TransactionPage from '../TransactionPage';

export default TransactionPage;
